export default __webpack_public_path__ + "static/media/LebenswerkHRservice.40cf15fe.svg";